import type { NbSignal, SclNode } from "../lib/jsonContracts";
interface Pending { resolve:(v:unknown)=>void; reject:(e:Error)=>void; }
let worker: Worker|null = null;
let nextId = 0;
const pending = new Map<number,Pending>();
function ensureWorker(): Worker {
  if (worker) return worker;
  worker = new Worker(new URL("./worker.ts", import.meta.url), { type:"module" });
  worker.onmessage = (ev: MessageEvent) => {
    const { id, ok, result, error } = ev.data;
    const p = pending.get(id);
    if (!p) return;
    pending.delete(id);
    ok ? p.resolve(result) : p.reject(new Error(error ?? "Error en el worker"));
  };
  return worker;
}
function call<T>(method: string, args: unknown[]): Promise<T> {
  const w = ensureWorker(), id = (nextId+=1);
  return new Promise<T>((resolve, reject) => {
    pending.set(id, { resolve:(v)=>resolve(v as T), reject });
    w.postMessage({ id, method, args });
  });
}
export function loadModels(url: string): Promise<void>          { return call<void>("loadModels",[url]); }
export function predictBatch(signals: string[], iedRef: string, modelOverride?: string): Promise<NbSignal[]> { return call<NbSignal[]>("predictBatch",[signals,iedRef,modelOverride]); }
export function validateInScl(rows: NbSignal[], sclNodes: SclNode[]): Promise<NbSignal[]> { return call<NbSignal[]>("validateInScl",[rows,sclNodes]); }
